export const parseNumberLocalize = (value, locale = "en-US") => {
  if (!value) return NaN;

  const separators = new Intl.NumberFormat(locale).formatToParts(1234.5).reduce((acc, part) => {
    if (part.type === 'group') acc.group = part.value;
    if (part.type === 'decimal') acc.decimal = part.value;
    return acc;
  }, {});

  const regex = new RegExp(`\\${separators.group}`, 'g');
  const normalizedValue = value.replace(regex, '').replace(separators.decimal, '.');

  return parseFloat(normalizedValue);
};

export const getLocale = (locale) => {
  if (typeof locale === 'string' && locale.trim().length > 0) {
    return locale.includes('_') ? locale.replace(/_/g, '-') : locale;
  } else {
    return window.navigator.language ||
    window.navigator.userLanguage ||
    window.navigator.browserLanguage ||
    'en-US';
  }
}

export const getSanitizedValidNumber = (inputValue) => {
  if(typeof inputValue === 'string' || typeof inputValue === 'number') {
    const stringNumber = typeof value === 'string' ? inputValue : inputValue.toString();

    // Remove any non-numeric characters except for digits, decimal point, comma and hyphen
    const sanitizedValue = stringNumber.replace(/[^\d.,-]/g, '');

    // Get the last occurrence of comma and period in the sanitized string
    const lastCommaIndex = sanitizedValue.lastIndexOf(',');
    const lastPeriodIndex = sanitizedValue.lastIndexOf('.');

    const lastChar = lastCommaIndex > lastPeriodIndex ? ',' : lastPeriodIndex > -1 ? '.' : 'none';

    // ( must be only 1 decimal ( comma or period)) Invalid values e.g 1.234.567,00,00 || 1,234,567.00.00 Should return null
    if ((lastChar === ',' && sanitizedValue.split(',').length > 2) || 
        (lastChar === '.' && sanitizedValue.split('.').length > 2)) {
      return null;
    }

    return sanitizedValue;
  }

  return null;
}

export const getValidNumberWithLocalize = (value, locale = "en-US") => {
  const sanitizedValue = getSanitizedValidNumber(value);
  if(sanitizedValue) {
    return parseNumberLocalize(sanitizedValue, locale)
  }

  return null;
}
